'use strict';

function formFirstStep(offerID, context) {

  return new Promise(function (resolve, reject) {

    var formOffer = $('#form-offer-' + offerID);
    var formFirstStep = formOffer.find('.form-offer-first');
    var phoneElement = formFirstStep.find('.phone');

    var latitude = null;
    var longitude = null;

    getLocationUser().then(function (coordinates) {
      latitude = coordinates['latitude'];
      longitude = coordinates['longitude'];
    });

    formValidateConfig(formFirstStep);
    maskPhone(phoneElement);
    validatorEmail();
    validatorPhone();

    formFirstStep.submit(function (event) {
      event.preventDefault();

      var form = $(this),
          tempName = form.find('.name').val().trim(),
          tempSurname = form.find('.surname').val() ? form.find('.surname').val().trim() : null,
          fullName = tempName.replace(/( )+/g, ' '),
          name = tempSurname ? fullName : fullName.split(' ')[0],
          surname = tempSurname ? tempSurname : fullName.indexOf(' ') !== -1 ? fullName.substr(fullName.indexOf(' ') + 1) : '',
          email = form.find('.email').val(),
          phone = form.find('.phone').val(),
          oferta = offerID,
          button = form.find('button[type="submit"]'),
          optIns = {},
          lgpd = [];

      form.find(".jc-opt-in").each(function () {
        optIns[$(this).attr('name')] = $(this).prop('checked');

        if ($(this).prop('checked')) {
          lgpd.push([$(this).attr('name'), $(this).parent(".form-group").text().trim(), $(this).parent(".form-group").find('a') ? $(this).parent(".form-group").find('a').attr('href') : null]);
        }
      });

      if (form.valid()) {

        var buttonLabel = button.text();
        button.prop('disabled', true).html('<i class="fa fa-cog fa-spin fa-fw"></i> Enviando...');

        grecaptcha.enterprise.ready(function () {
          grecaptcha.enterprise.execute(ajaxHandler.siteKey, { action: 'save_lead' }).then(function (grecaptchaToken) {

            var additionalData = {};
            $('.additional').each(function () {
              additionalData[$(this).attr('name')] = $(this).val();
            });

            $.ajax({
              url: ajaxHandler.url,
              type: 'POST',
              data: {
                action: 'jc_ajax_template_second_modal',
                oferta: oferta
              },
              success: function success(response) {
                if (response && response.success) {
                  var secondStep = response.data.templateSecondStep;

                  $.ajax({
                    url: ajaxHandler.url_leads + '/api/jornaldocarro/v1/receive-callback/first-step',
                    type: 'POST',
                    data: {
                      action: 'jc_ajax_offer_save_lead_first_step',
                      context: context,
                      name: name,
                      surname: surname,
                      email: email,
                      phone: phone,
                      oferta: oferta,
                      url_page: window.location.href,
                      optIns: encodeURIComponent(JSON.stringify(optIns)),
                      lgpd: encodeURIComponent(JSON.stringify(lgpd)),
                      getParameters: encodeURIComponent(JSON.stringify(getUrlVars())),
                      latitude: latitude,
                      longitude: longitude,
                      additionalData: additionalData,
                      token: grecaptchaToken
                      // secondStep      : secondStep
                    },
                    success: function success(response) {
                      if (response && response.success) {
                        formFirstStep.replaceWith(secondStep);
                        resolve(response.data.leadID);
                      } else {
                        populateAndShowFormError(formOffer, response.data);
                        button.prop('disabled', false).html(buttonLabel);
                      }
                    },
                    error: function error(data) {
                      showFormError(formOffer);
                      button.prop('disabled', false).html(buttonLabel);
                    }
                  });
                }
              }
            });
          });
        });
      }
    });
  });
}